import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { fetchMyClubs } from "../../services/clubsApi";
import { useAuth } from "../../context/AuthContext";

export default function ClubsEntryPage() {
  const navigate = useNavigate();
  const { user, authLoading, isAuthenticated } = useAuth();
  const [wait, setWait] = useState(true);

  useEffect(() => {
    if (authLoading) return;

    let alive = true;

    async function route() {
      if (!isAuthenticated || !user) {
        if (alive) navigate("/clubs/discover", { replace: true });
        return;
      }

      try {
        const data = await fetchMyClubs();
        const list = Array.isArray(data?.clubs) ? data.clubs : [];
        if (!alive) return;
        if (list.length > 0) {
          navigate("/clubs/my-clubs", { replace: true });
        } else {
          navigate("/clubs/discover", { replace: true });
        }
      } catch {
        if (alive) navigate("/clubs/discover", { replace: true });
      } finally {
        if (alive) setWait(false);
      }
    }

    route();
    return () => {
      alive = false;
    };
  }, [authLoading, isAuthenticated, user, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#060812] text-white/70">
      <p className="text-sm tracking-wide">{wait ? "Loading clubs…" : "Redirecting…"}</p>
    </div>
  );
}
